import React, { useState } from 'react';
import { Event, EventRoleEnum } from './API';
import { addUserToEvent } from './mutations/processCreateEventUser';
import { CreateEventUserInput } from './API';
import { Button, Input, EmailIcon } from '@uclaea/react-component-library';
import './css/Modal.css';

interface AddUserProps {
  eventDetails: Event;
  onClose: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}

const AddUser: React.FC<AddUserProps> = ({ eventDetails, onClose, onSuccess, onError }) => {
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!email.includes('ucla.edu')) {
      setEmailError('Email must be a valid UCLA email address (contain "ucla.edu").');
      return;
    }
    setEmailError(null);
    const { eventId } = eventDetails;

    const addUserSubmitData: CreateEventUserInput = {
      eventId,
      ownerEmail: email,
      eventRole: EventRoleEnum.TEAM, // Set the role to TEAM or any other role as needed
    };

    try {
      const result = await addUserToEvent(addUserSubmitData);
      console.log('Event user created:', result);
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error('Error creating event user:', err);
      alert('Failed to add the user to the event. Please try again.');
      if (onError) onError();
    }
  };

  const onSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit().catch((err) => {
      console.error('Failed to submit form:', err);
      alert('An unexpected error occurred. Please try again.');
      if (onError) onError();
    });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Add User to {eventDetails.eventName}</h2>
        <p>
          Give team members permissions to manage check-ins using this App.
          <br />
          Email must be associated with a valid UCLA LOGON account.
          <br />
          To create an account visit <a href='https://accounts.iam.ucla.edu/register' target="_blank" rel="noopener noreferrer">UCLA IAM</a>.
        </p>
        <form onSubmit={onSubmitHandler}>
          <Input
            label="User Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            placeholder="Enter user email"
            required
            icon={{ left: EmailIcon }}
            error={emailError ?? undefined}
          />
          <br />
          <Button variant="primary" label="Invite" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default AddUser;
